/* istanbul ignore file */
import { createPermission } from "@backstage/plugin-permission-common";

/**
 * STAN Read Permission
 * Grants access to: Dashboard, Agents, Policy Rules
 */
export const stanReadPermission = createPermission({
  name: "stan.read",
  attributes: { action: "read" },
});

/**
 * STAN Tasks Permission
 * Grants access to: Dashboard, Agents, Policy Rules, Tasks
 */
export const stanTasksPermission = createPermission({
  name: "stan.tasks",
  attributes: { action: "read" },
});

/**
 * STAN Admin Permission
 * Grants access to: Dashboard, Agents, Policy Rules, Tasks, Logs
 */
export const stanAdminPermission = createPermission({
  name: "stan.admin",
  attributes: { action: "read" },
});

/**
 * HR Write Permission
 * Grants access to: HR SF Upload
 */
export const hrWritePermission = createPermission({
  name: "hr.write",
  attributes: { action: "create" },
});
